import './App.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';

// HashRouter to handle non defined server side routes
import { HashRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './components/home/Home';
// import ProtectedRoute from './components/ProtectedRoute';

import SignIn from './components/auth/SignnIn';
import Navbar from './components/Header';
import Servers from './components/servers/Servers';
import Reports from './components/reports/Reports';
import AccessControl from './components/access/AccessControl';
import Lifecycle from './components/lifecycle/Lifecycle';
import ScheduledUpdate from './ScheduledUpdated';
import Licenses from './components/superAdmin/licenses/Licneses';
import ApprovedSites from './components/superAdmin/approvedSites/ApprovedSites';
import Faq from './components/resources/Faq';
import Videos from './components/resources/Videos';
import ContactUs from './components/resources/ContactUs';
import Installer from './components/resources/installer/Installer.js';
import InvitationConfirmPage from './components/invite/InvitationConfirmation';
import SideBarNew from './components/SideBarNew.js';
import MatterportModelViewer from './components/matterport/MatterportViewer';

library.add(fas);

function App() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
  const [soundEnabled, setSoundEnabled] = useState(true); // enable audio

  useEffect(() => {
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);
  
  return (
    <Router>
      {!isSmallScreen && <SideBarNew />}
      <Navbar isSmallScreen={isSmallScreen} soundEnabled={soundEnabled} setSoundEnabled={setSoundEnabled}/>
      <ScheduledUpdate />
      <Routes>
        <Route exact path='/' element={<Home />}></Route>
        <Route exact path='/health' element={<Servers soundEnabled={soundEnabled}/>}></Route>
        <Route exact path='/report' element={<Reports />}></Route>
        <Route exact path='/admin' element={<AccessControl />}></Route>
        <Route exact path='/licenses' element={<Licenses />}></Route>
        <Route exact path='/sites' element={<ApprovedSites />}></Route>
        
         {/* Matterport 3D Viewer Route - Simple hardcoded version for testing */}
        <Route 
          exact 
          path='/matterport' 
          element={
           <MatterportModelViewer
              modelId="QBRgzDJyp7F"
            />

          }
        />

        <Route exact path='/faq' element={<Faq />}></Route>
        <Route exact path='/installer/faq' element={<Installer goback="faq"/>}></Route>
        <Route exact path='/installer/health' element={<Installer goback="health"/>}></Route>
        <Route exact path='/videos' element={<Videos />}></Route>
        <Route exact path='/contact-us/support' element={<ContactUs type="support"/>}></Route>
        <Route exact path='/contact-us/sales' element={<ContactUs type="sales"/>}></Route>
        <Route exact path='/lifecycle' element={<Lifecycle />}></Route>
        <Route exact path='/auth/signin' element={<SignIn />}></Route>
        <Route path='/invite/confirm-invitation' element={<InvitationConfirmPage />} ></Route>
        <Route exact path='/matterport' element={<MatterportModelViewer  />} />
      </Routes>
     
    </Router>
  );
}

export default App;
